import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Box,
} from "@mui/material";

export default function EMPToggleButtons({ groupHeading, items, onChange }) {
  const [alignment, setAlignment] = useState(items[0]?.value);

  const handleChange = (e, newAlignment) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
      onChange(newAlignment);
    }
  };

  return (
    <>
      <Box mb={2}>
        <Typography variant="caption">{groupHeading}</Typography>
      </Box>
      <ToggleButtonGroup
        color="primary"
        value={alignment}
        exclusive
        onChange={handleChange}
        fullWidth
        size="large"
      >
        {items.map((item) => (
          <ToggleButton value={item.value} key={item.value}>
            {item.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </>
  );
}

EMPToggleButtons.propTypes = {
  groupHeading: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  onChange: PropTypes.func,
};

EMPToggleButtons.defaultProps = {
  groupHeading: "",
  items: [],
  onChange: undefined,
};
